import doctor1 from "assets/images/doctors/23.jpg";
import doctor2 from "assets/images/doctors/21.jpg";
import doctor3 from "assets/images/doctors/9.jpg";
import doctor4 from "assets/images/doctors/16.jpg";
import doctor5 from "assets/images/doctors/20.jpg";
import doctor6 from "assets/images/doctors/1.jpg";
import doctor7 from "assets/images/doctors/12.jpg";

const doctors = [
  {
    id: "dr-m-sohanraj",
    slug: "dr-m-sohanraj",
    name: "Dr. M Sohanraj",
    designation: " Medical Director, Amrit Hospital",
    qualifications: "MBBS, DOMS, MS(OPHTHAL), FRSH, FICS(USA)",
    photo: doctor1, 
    hospital: "Amrit Hospitals",
    short:"",
    bio: `He co-founded Amrit Hospital (formerly Ashwini Eye Clinic) in 1994 with his wife, Dr. Vimala. He received the Seva Ratna and IMA awards and is a member of AIOS, IMA, ESCRS, and the Tamil Nadu Medical Council.`,
    highlights: [
      "MICS (Micro Incision Cataract Surgery)",
      "Pediatric Squint Surgery",
      "Oculoplasty Surgery",
    ],
    Surgeries:"2 Lacs+ Surgeries Performed",
     opdex: {
      location: "40 Years of Experience",
    },
    opd: {
      location: "Purasawalkam",
      timings: [
        { days: "Monday to Saturday", time: "11:00 AM - 03:00 PM" },
        
      ],
    },
    opd2: {
      location: "Sowcarpet",
      timings: [
        { days: "Monday to Saturday", time: "06:00 AM - 09:00 PM" },
       
      ],
    },
    contact: {
      phone: "+919600711818",
      //email: "lalit.kumar@amrithospital.in",
    },
    meta: {
      title: "Amrit Hospitals",
      description:
        "",
    },
   
  },

  {
    id: "dr-sonal-rajesh-kumar",
    slug: "dr-sonal-rajesh-kumar",
    name: "Dr. Sonal Rajesh Kumar",
    designation: "Consultant Physician",
    qualifications: "MBBS, MD (General Medicine)",
    photo: doctor2, 
    hospital: "Amrit Hospitals",
     Surgeries:"",
    short:
      "",
    bio: `Completed MD - Physician from Tbilisi State Medical University, Georgia in 2014. MD General Medicine from SRM University in 2018. Member of the Indian Medical Association`,
    highlights: [
      "MICS (Micro Incision Cataract Surgery)",
      "Pediatric Squint Surgery",
      "Oculoplasty Surgery",
    ],
    
     opdex: {
      location: "7 Years of Experience",
    },
    opd: {
      location: "Purasawalkam",
      timings: [
        { days: "Saturday", time: "10:30 - 12:00 PM, 6:30 - 8:30" },
        
      ],
    },
    opd2: {
      location: "Sowcarpet",
      timings: [
        { days: "Saturday", time: "6:00 - 9:00 PM" },
       
      ],
    },
    contact: {
      phone: "+919600711818",
      //email: "lalit.kumar@amrithospital.in",
    },
    meta: {
      title: "Amrit Hospitals",
      description:
        "",
    },
   
  },

  {
    id: "dr-vimala-sohan-raj",
    slug: "dr-vimala-sohan-raj",
    name: "Dr. Vimala Sohan Raj",
    designation: "Obstetrician and Gynaecologist, Infertility Specialist, Laparoscopic Surgeon.",
    qualifications: "B.Sc., MBBS, DGO",
    photo: doctor3, 
    hospital: "Amrit Hospitals",
    short:
      "",
    bio: `EXPERT IN CRITICAL SURGERIES`,
   
     opdex: {
      location: "40 Years of Experience",
    },
    opd: {
      location: "Purasawalkam",
      timings: [
        { days: "Monday to Saturday", time: "11:00 - 1:00 PM" },
        
      ],
    },
    opd2: {
      location: "Sowcarpet",
      timings: [
        { days: "Monday to Saturday", time: "6:30 - 9:00 PM" },
       
      ],
    },
    contact: {
      phone: "+919600711818",
      //email: "lalit.kumar@amrithospital.in",
    },
    meta: {
      title: "Amrit Hospitals",
      description:
        "",
    },
   
  },

  {
    id: "dr-lalit-kumar",
    slug: "dr-lalit-kumar",
    name: "Dr. Lalit Kumar",
    designation: "Cataract, Cornea and Refractive Surgeon",
    qualifications: " MBBS, MS(OPH), FICO(UK)",
    photo: doctor4, 
    hospital: "Amrit Hospitals",
    short:"",
    bio: `Member of AIOS, AAO, ESCRS, and Tamil Nadu Medical Council`,
    Surgeries:"2 LACS+ SURGERIES PERFORMED",
    highlights: [
      "LenSx Femtosecond/Robotic Cataract",
      "MICS (Micro Incision Cataract Surgery)",
      "Minimally Invasive Glaucoma Surgery (MIGS)",
      "SMILE Pro",
      "ReLEx SMILE",
      "Femtosecond CONTOURA LASIK",
    ],
    
     opdex: {
      location: "21 Years of Experience",
    },
    opd: {
      location: "Purasawalkam",
      timings: [
        { days: "Monday to Saturday", time: "3:00 - 8:00 PM, Sun 11:00 - 2:00 PM" },
        
      ],
    },
   
    contact: {
      phone: "+919600711818",
      //email: "lalit.kumar@amrithospital.in",
    },
    meta: {
      title: "Amrit Hospitals",
      description:
        "",
    },
   
  },


{
    id: "dr-shalini-lalit-kumar",
    slug: "dr-shalini-lalit-kumar",
    name: "Dr. Shalini Lalit Kumar",
    designation: "Obstetrician & Gynaecologist, Infertility Specialist, Laparoscopic Surgeon",
    qualifications: "MBBS, MS(OBG)",
    photo: doctor5, 
    hospital: "Amrit Hospitals",
    short:"",
    bio: ``,
    highlights: [
      "Reproductive endoscopic procedures like Hysteroscopy",
      "Laparoscopy. Uterine Anomalies, PCOD, etc",
      "Laparoscopy, Gynaecology, Infertility",
    ],
    Surgeries:"MANAGES HIGH RISK PREGNANCY",
     opdex: {
      location: "18+ Years of Experience",
    },
    opd: {
      location: "Purasawalkam",
      timings: [
        { days: "Monday to Saturday", time: "6:30 - 8:30 PM" },
        
      ],
    },
    opd2: {
      location: "Sowcarpet",
      timings: [
        { days: "Monday to Saturday", time: "12:30 - 4:30 PM" },
       
      ],
    },
    contact: {
      phone: "+919600711818",
      //email: "lalit.kumar@amrithospital.in",
    },
    meta: {
      title: "Amrit Hospitals",
      description:
        "",
    },
   
  },

{
    id: "dr-rajesh-kumar",
    slug: "dr-rajesh-kumar",
    name: "Dr. Rajesh Kumar",
    designation: " Consultant Ophthalmologist, Vitreo Retinal Surgeon",
    qualifications: "MBBS, MS (Ophthal), FVRS",
    photo: doctor6, 
    hospital: "Amrit Hospitals",
    short:"",
    bio: ``,
    highlights: [
      "Fellowship in Vitreo Retinal Surgeon",
      "Sutureless Vitreo Retinal Surgery",
      "Medical Retina Services",
      "Micro Incision Cataract Surgery",
    ],
    Surgeries:"1000+ SURGERIES PERFORMED",
     opdex: {
      location: "10+ Years of Experience",
    },
    opd: {
      location: "Purasawalkam",
      timings: [
        { days: "Fri", time: "9:00 AM Onwards" },
        
      ],
    },
   
    contact: {
      phone: "+919600711818",
      //email: "lalit.kumar@amrithospital.in",
    },
    meta: {
      title: "Amrit Hospitals",
      description:
        "",
    },
   
  },

  {
    id: "dr-chetan-kumar",
    slug: "dr-chetan-kumar",
    name: "Dr. Chetan Kumar",
    designation: "Consultant Ophthalmologist, Vitreo Retinal Surgeon",
    qualifications: " MBBS, MS (Ophthal), FVRS",
    photo: doctor7, 
    hospital: "Amrit Hospitals",
    short:"",
    bio: ``,
    highlights: [
      "Fellowship in Vitreo Retinal Surgeon",
      "Sutureless Vitreo Retinal Surgery",
      "Medical Retina Services",
      "Micro Incision Cataract Surgery",
    ],
    Surgeries:"1000+ SURGERIES PERFORMED",
     opdex: {
      location: "10 Years of Experience",
    },
    opd: {
      location: "Purasawalkam",
      timings: [
        { days: "Fri", time: " 9:00 AM Onwards" },
        
      ],
    },
    
    contact: {
      phone: "+919600711818",
      //email: "lalit.kumar@amrithospital.in",
    },
    meta: {
      title: "Amrit Hospitals",
      description:
        "",
    },
   
  },


];

export default doctors;
